import { render, staticRenderFns } from "./quanxiancelueguanli.vue?vue&type=template&id=3b317557"
import script from "./quanxiancelueguanli.vue?vue&type=script&lang=js"
export * from "./quanxiancelueguanli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports